import Vue from 'vue'
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import {
  ADD_ORDER, BUMP_ORDER, CANCEL_ORDER,
  CONFIRM_ORDER,
  LOAD_ORDERS_LIST,
  RESET_ORDERS,
  RESTART_ORDER
} from "@/store/const/orders";
import { LOAD_CSV_STATS, LOAD_STATS } from '@/store/const/orders';

export default {
  namespaced: true,
  state: {
    orders: {
      list: [],
      pagination: {},
    },
    statuses: {
      wait_send: 'Ожидает отправки',
      processing: 'Отправка',
      requested: 'Запрошен',
      success: 'Выполнен',
      finished: 'Завершен',
      error: 'Ошибка',
      canceled: 'Отменен',
    },
    stats: {},
  },
  getters: {
    orders: state => state.orders,
    statuses: state => state.statuses,
    stats: state => state.stats,
  },
  actions: {
    [LOAD_ORDERS_LIST]: async ({ dispatch }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_ORDERS_LIST,
        namespace: 'orders',
        params,
      }, { root: true });
    },
    [ADD_ORDER]: async ({ dispatch }, data) => {
      return await dispatch(HTTP_POST, {
        method: ADD_ORDER,
        namespace: 'orders',
        no_commit: true,
        body: data,
      }, { root: true });
    },
    [CONFIRM_ORDER]: async ({ dispatch }, { id }) => {
      return await dispatch(HTTP_PUT, {
        method: CONFIRM_ORDER,
        namespace: 'orders',
        no_commit: true,
        replace: { id },
      }, { root: true });
    },
    [RESTART_ORDER]: async ({ dispatch }, { id }) => {
      return await dispatch(HTTP_PUT, {
        method: RESTART_ORDER,
        namespace: 'orders',
        no_commit: true,
        replace: { id },
      }, { root: true });
    },
    [BUMP_ORDER]: async ({ dispatch }, { id, params = {} }) => {
      return await dispatch(HTTP_PUT, {
        method: BUMP_ORDER,
        namespace: 'orders',
        no_commit: true,
        params,
        replace: { id },
      }, { root: true });
    },
    [CANCEL_ORDER]: async ({ dispatch }, { id }) => {
      return await dispatch(HTTP_DELETE, {
        method: CANCEL_ORDER,
        namespace: 'orders',
        no_commit: true,
        replace: { id },
      }, { root: true });
    },
    [LOAD_STATS]: async ({ dispatch }, { from, to, stats_by }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_STATS,
        namespace: 'orders',
        params: { from, to, stats_by },
      }, { root: true });
    },
    [LOAD_CSV_STATS]: async ({ dispatch }, { from, to, user, stats_by }) => {
      const request = await dispatch(HTTP_GET, {
        method: LOAD_CSV_STATS,
        namespace: 'orders',
        isFile: true,
        no_commit: true,
        params: { from, to, user, stats_by },
      }, { root: true });
      const blob = new Blob([request.data]);
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `report-${user}.csv`;
      link.click()
      URL.revokeObjectURL(link.href)
    },
  },
  mutations: {
    [LOAD_ORDERS_LIST]: (state, { data }) => {
      Vue.set(state.orders, 'list', data.list);
      Vue.set(state.orders, 'pagination', data.pagination);
    },
    [LOAD_STATS]: (state, { data = {} }) => {
      Vue.set(state, 'stats', data);
    },
    [RESET_ORDERS]: (state) => {
      Vue.set(state, 'orders', { pagination: {}, list: []});
      Vue.set(state, 'stats', {});
    }
  },
};
